import React from 'react';
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import splitLine from "ReactApp/Services/MotionHelpers/SplitLine";
import {priceFormatter} from "ReactApp/Services/Formatters/PriceFormatter";
import {observer} from "mobx-react";
import {BuyBtnV1} from "ReactApp/Components/BuyBtnV1/BuyBtnV1";
import { CommonLabelsEnum, ProductSaleStatusTypeEnum } from 'ReactApp/Types/enum';

type TabPanelPriceBlockV1Props = {
    productCard: ShowableProductCard
}

const TabPanelPriceBlockV1 = observer((props: TabPanelPriceBlockV1Props) => {

    const {currentProductConfig} = props.productCard;
    const {salePrice} = props.productCard;
    const {oldPrice} = props.productCard;

    //eсли нет продажной цены не рендерим блок
    if(salePrice === null)
        return <></>;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }

    const uniqueKey = currentProductConfig.getUniqueId();

    return (
        <div key={uniqueKey}>
            <div className="product-tab-v1__price">
                {props.productCard.saleStatusType === ProductSaleStatusTypeEnum.inStock && (
                    <>
                        <div className="old-price-v1"
                            data-product-field-key={oldPrice?.key}
                        >
                            <span className="old-price-v1__value">
                                {splitLine(priceFormatter.format(
                                    Number(oldPrice?.value)
                                ))}
                            </span>
                        </div>
                        <div className="sale-price-v1"
                            data-product-field-key={salePrice?.key}
                        >
                            {splitLine(priceFormatter.format(
                                Number(salePrice?.value)
                            ))}
                        </div>
                    </>
                )}
                {props.productCard.saleStatusType === ProductSaleStatusTypeEnum.discontinued && (
                    <div className="sale-price-v1 sale-price-v1__no-price"
                        data-product-field-key={salePrice?.key}
                    >
                        {splitLine(CommonLabelsEnum.productDiscontinued)}
                    </div>
                )}
            </div>
            {props.productCard.saleStatusType === ProductSaleStatusTypeEnum.inStock && (
                <>
                    <BuyBtnV1 {...{
                        productCard: props.productCard
                    }}/>
                    <div className="product-tab-v1__installment-price-from">
                        Рассрочка от {
                            splitLine(priceFormatter.format(
                                Number(salePrice?.value))
                            )
                        }/мес.
                    </div>
                </>
            )}
        </div>
    );
})

export {TabPanelPriceBlockV1};